export const customFilterOption = (option, rawInput) => {
    if (!rawInput) return true;

    // Normalize input and label
    const input = rawInput.toLowerCase().trim();
    const label = option.label.toLowerCase();

    // Split input into words (e.g., "123 aniket" => ["123", "aniket"])
    const words = input.split(/\s+/);

    // Check if *every* word exists somewhere in label
    return words.every(word => label.includes(word));
};